import { z } from 'zod';
import { ISimulationPayload } from '../types';
import { validateUnitPreset } from './helpers/unit-preset-validator';

export const validateStep3TargetScenario = (params: {
  data: ISimulationPayload;
  targetIndex: number;
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  };
  energyPricesProjection?: Record<string, number> | null;
  marginFeeProjection?: Record<string, number> | null;
}): boolean => {
  let hasErrors = false;
  const { data, targetIndex, ctx, energyPricesProjection, marginFeeProjection } = params;
  const targetScenarios = data?.inputs?.parsedPayload?.targetScenarios;
  const useDifferentPeriodsByUnit = data?.inputs?.parsedPayload?.aux__useDifferentPeriodsByUnit ?? false;

  const targetScenario = targetScenarios?.[targetIndex];

  const scenarioPayload = targetScenario?.scenarioPayload;

  const globalSupplyStartDate = data?.inputs?.parsedPayload?.aux__useGlobalSupplyStartDate;
  const globalSupplyFinalDate = data?.inputs?.parsedPayload?.aux__useGlobalSupplyFinalDate;

  scenarioPayload?.forEach((unitPreset, unitIndex) => {
    const basePath = ['inputs', 'parsedPayload', 'targetScenarios', targetIndex, 'scenarioPayload', unitIndex];
    const validateParams = {
      unitPreset,
      basePath,
      ctx,
      useDifferentPeriodsByUnit,
      globalSupplyStartDate,
      globalSupplyFinalDate,
      energyPricesProjection,
      marginFeeProjection,
    };
    const isValid = validateUnitPreset(validateParams);
    if (!isValid) hasErrors = true;
  });

  return !hasErrors;
};
